"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormContext = void 0;
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var Message_1 = __importDefault(require("../Message/Message"));
var Padder_1 = require("../Padder");
exports.useFormContext = formik_1.useFormikContext;
var FormMessage = function (_a) {
    var submitCount = _a.submitCount, props = __rest(_a, ["submitCount"]);
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [submitCount, props.children]);
    return (react_1.default.createElement(Padder_1.Padder, null,
        react_1.default.createElement(Message_1.default, __assign({ ref: ref }, props))));
};
var getErrors = function (errors) {
    try {
        return Object.entries(errors).reduce(function (acc, _a) {
            var value = _a[1];
            if (typeof value === 'object' && value !== null && Object.keys(value).length) {
                return __spreadArrays(acc, getErrors(value));
            }
            if (typeof value === 'string') {
                return __spreadArrays(acc, [value]);
            }
            return acc;
        }, []);
    }
    catch (e) {
        return [];
    }
};
function Form(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(formik_1.Formik, __assign({}, props, { validateOnBlur: false, validateOnChange: false }), function (p) {
        var status = p.status;
        return (react_1.default.createElement(formik_1.Form, null,
            status && ramda_1.isEmpty(p.errors) && (react_1.default.createElement(FormMessage, { submitCount: p.submitCount, onClose: function () { return p.setStatus(undefined); }, type: status.type }, status.message)),
            !ramda_1.isEmpty(p.errors) && (react_1.default.createElement(FormMessage, { submitCount: p.submitCount, onClose: function () { return p.setErrors({}); }, type: "error" }, getErrors(p.errors).join('. '))),
            children(p)));
    }));
}
exports.default = Form;
